import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const storagePending = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_STORAGE_PENDING]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_STORAGE_PENDING]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_STORAGE_PENDING_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.EMPTY_STORAGE_PENDING_CARS]: (state) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
